import { LitElement, html, css } from 'lit'
import { focusTrap } from '../../lib/focus-trap'

export class DropdownButton extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      slot[name='button'] {
        cursor: pointer;
      }

      .dropdown-container {
        position: relative;
        width: 100%;
      }

      .dropdown-menu {
        opacity: 0;
      }
      slot[aria-expanded='true'] + .dropdown-menu {
        opacity: 1;
      }
    `,
  ]

  static properties = {
    active: { type: Boolean, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.active = false

    this.focusTrap = new focusTrap({
      el: this,
      includeActiveElement: false,
      escCallback: () => {
        this._toggle()
      },
    })

    this.windowClickHandler = (e) => {
      let dropdownComponent = this
      let dropdownMenuEl = this.querySelector('[slot="dropdown"]')

      if (
        !(dropdownComponent == e.target || dropdownComponent.contains(e.target)) &&
        !(e.target.nodeName === 'DROPDOWN-BUTTON')
      ) {
        this._toggle()
      }

      if (dropdownMenuEl.contains(e.target)) {
        setTimeout(() => {
          this._toggle()
        }, 200)
      }
    }
  }

  firstUpdated() {
    this.querySelector('[slot="dropdown"]').classList.add('loaded')
  }

  render() {
    return html`
      <div class="dropdown-container">
        <slot name="button" aria-expanded=${this.active} @click=${this._onClick}></slot>
        <div class="dropdown-menu" hidden>
          <slot name="dropdown"></slot>
        </div>
      </div>
    `
  }

  _onClick() {
    this._toggle()
  }

  _toggle() {
    this.menu = this.shadowRoot.querySelector('.dropdown-menu')
    this.button = this.renderRoot.querySelector('[name="button"]').assignedElements()[0]
    this.active = !this.active
    this.button.setAttribute('aria-expanded', this.active)
    if (this.active) {
      this.focusTrap.activate()
      this.menu.removeAttribute('hidden')
      window.addEventListener('click', this.windowClickHandler)
    } else {
      this.focusTrap.deactivate()
      this.menu.setAttribute('hidden', 'true')
      window.removeEventListener('click', this.windowClickHandler)
    }
  }
}
customElements.define('dropdown-button', DropdownButton)
